<template>
  <div class="contenedor">
    <element-loading :active="loadingIn">
      <img
        src="img/loading_latino.gif"
        width="75px"
        height="75px"
        style="margin-top: 100px"
      />
    </element-loading>

    <div v-if="contenedor">
      <!-- div controles busqueda NO Filiales-->
      <div v-if="isFilial == 0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-lg-4 mb-3">
                <label class="form-label"
                  >Nombre completo del contratante</label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="nombreContratante"
                  placeholder="Nombre contratante"
                />
              </div>
              <div class="col-md-1 col-lg-1 mb-3">
                <button
                  @click="modalInformation = true"
                  class="btn btn-info mt-4 mr-3"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- div controles busqueda Filiales-->
      <div v-if="isFilial == 1">
        <div class="card">
          <div class="card-body">
            <label class="form-label"
              >Una póliza de FILIAL se puede domiciliar a una tarjeta, ya sea
              indicando si se cobrará toda la póliza o indicando Filiales
              específicas.</label
            >
            <div class="row">
              <div class="col-md-4 col-lg-4">
                <label class="form-label"
                  >Nombre completo del contratante</label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="nombreContratante"
                  placeholder="Nombre contratante"
                />
              </div>
              <div class="col-md-2 col-lg-2 mt-4 ml-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  @change="check($event)"
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Domiciliar Póliza completa
                </label>
              </div>
              <div class="col-md-1 col-lg-1 mb-3">
                <button
                  @click="modalInformation = true"
                  class="btn btn-info mt-3 mr-3"
                >
                  Buscar
                </button>
              </div>
            </div>
            <div v-if="filiales">
              <label class="visually-hidden mt-4"
                >Se pueden agregar hasta 4 filiales. Una vez ingresado los datos
                de las filiales hay que hacer clic en Buscar.</label
              >
              <div class="row">
                <div class="col-sm-2 col-md-2"></div>
                <div class="col-sm-8 col-md-8">
                  <form>
                    <div class="row">
                      <div class="col-1">
                        <span class="badge bg-secondary numero mt-1 mb-1"
                          >1</span
                        >
                      </div>
                      <div class="col-3 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.numeroFilial1"
                          placeholder="Número Filial"
                          required
                        />
                      </div>
                      <div class="col-6 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.nombreFilial1"
                          placeholder="Nombre Filial"
                          required
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1">
                        <span class="badge bg-secondary numero mt-1 mb-1"
                          >2</span
                        >
                      </div>
                      <div class="col-3 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.numeroFilial2"
                          placeholder="Número Filial"
                        />
                      </div>
                      <div class="col-6 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.nombreFilial2"
                          placeholder="Nombre Filial"
                        />
                      </div>
                    </div>
                  </form>

                  <form>
                    <div class="row">
                      <div class="col-1">
                        <span class="badge bg-secondary numero mt-1 mb-1"
                          >3</span
                        >
                      </div>
                      <div class="col-3 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.numeroFilial3"
                          placeholder="Número Filial"
                        />
                      </div>
                      <div class="col-6 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.nombreFilial3"
                          placeholder="Nombre Filial"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1">
                        <span class="badge bg-secondary numero mt-1 mb-1"
                          >4</span
                        >
                      </div>
                      <div class="col-3 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.numeroFilial4"
                          placeholder="Número Filial"
                        />
                      </div>
                      <div class="col-6 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filial.nombreFilial4"
                          placeholder="Nombre Filial"
                        />
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-sm-2 col-md-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Cards convenio y tarjeta -->
      <div v-if="habilitaTarjetas">
        <div class="card">
          <div class="card-header d-flex justify-content-between">
            <h5>Convenio</h5>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-3 mb-3">
                <label for="selectTipoConvenio" class="form-label"
                  >Tipo de convenio*</label
                >
                <select
                  class="form-control"
                  v-model="convenio.tipoConvenio"
                  @change="cambia($event, 'convenio')"
                  required
                >
                  <option
                    v-for="(tipo, i) in tiposConvenios"
                    :key="i"
                    :value="tipo.idTipoConvenio"
                  >
                    {{ tipo.tipoConvenio }}
                  </option>
                </select>
              </div>

              <div class="col-md-3 mb-3">
                <label for="selectBancos" class="form-label">Banco*</label>
                <select
                  id="selectBancos"
                  class="form-control"
                  @change="cambia($event, 'banco')"
                  v-model="convenio.banco"
                  name="banco"
                  required
                >
                  <option
                    v-for="(tipo, i) in bancos"
                    :key="i"
                    :value="tipo.idBanco"
                  >
                    {{ tipo.banco }}
                  </option>
                </select>
              </div>

              <div class="col-md-3 mb-3">
                <label for="inputCorreo" class="form-label"
                  >Correo electronico*</label
                >
                <input
                  type="email"
                  class="form-control"
                  id="inputCorreo"
                  v-model="convenio.correo"
                  name="email"
                  required
                />
              </div>

              <div class="col-md-3 mb-3">
                <label for="selectTipoPago" class="form-label"
                  >Tipo de Tarjeta*</label
                >
                <select
                  id="selectTipoPago"
                  class="form-control"
                  @change="cambia($event, 'tarjeta')"
                  name="tipoTarjeta"
                  v-model="convenio.tipoTarjeta"
                  required
                >
                  <option
                    v-for="(tipo, i) in tiposTarjetas"
                    :key="i"
                    :value="tipo.idTipoElemento"
                  >
                    {{ tipo.tipoElemento }}
                  </option>
                </select>
              </div>

              <div class="col-md-3 mb-3">
                <label for="selectSituacionDelConvenio" class="form-label"
                  >Situación del convenio*</label
                >
                <select
                  disabled
                  class="form-control"
                  aria-label="Default select example"
                >
                  <option
                    selected
                    v-for="(tipo, i) in situacionConvenios"
                    :key="i"
                    :value="tipo.idSituacionConvenio"
                  >
                    {{ situacionConvenios[1].situacionConvenio }}
                  </option>
                </select>
              </div>

              <div class="col-md-3 mb-3">
                <label for="inputPhone" class="form-label">Teléfono*</label>
                <input
                  class="form-control"
                  v-model="convenio.telefono"
                  name="telefono"
                  maxlength="10"
                  required
                />
                <!-- <input class="form-control" id="inputPhone" v-model="convenio.telefono" name="telefono" maxlength="10" v-on:keyup="replaceTelefono" required /> -->
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h5>Tarjeta</h5>
          </div>
          <div class="card-body d-flex flex-wrap">
            <div class="col-sm-12 col-lg-4 form-group">
              <label>Numero de tarjeta*</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="XXXX XXXX XXXX 0000"
                  v-model="tarjeta.numeroTarjeta"
                  v-on:keyup="replaceTarget"
                  :maxlength="maxL"
                  required
                />
              </div>
            </div>

            <div class="col-lg-4 form-group">
              <label>Titular*</label>
              <input
                type="text"
                class="form-control"
                placeholder="Nombre"
                v-model="tarjeta.titular"
                name="titular"
                requerid
              />
            </div>

            <div class="col-lg-2 col-sm-6 form-group">
              <label>Vencimiento*</label>
              <input
                type="text"
                class="form-control"
                placeholder="Mes"
                v-model="tarjeta.mes"
                name="mesVencimiento"
                required
                maxlength="2"
              />
              <!-- v-on:keyup="replaceMes" required maxlength="2" /> -->
            </div>

            <div class="col-lg-2 col-sm-6 form-group">
              <label style="margin-left: 6rem; color: white">.</label>
              <input
                type="text"
                class="form-control"
                placeholder="Año"
                v-model="tarjeta.año"
                name="anioVencimiento"
                required
                maxlength="4"
              />
              <!-- v-on:keyup="replaceAnio" required maxlength="4" /> -->
            </div>

            <div class="col-sm-3 col-lg-4 form-group">
              <label>CVV*</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="XXX"
                  v-model="tarjeta.cvv"
                  name="cvvTarjeta"
                  required
                  :maxlength="maxCVV"
                />
                <!-- v-on:keyup="replaceCVV" name="cvvTarjeta" required /> -->
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label for="selectSituacion" class="form-label">Situación*</label>
              <select
                disabled
                class="form-control"
                aria-label="Default select example"
              >
                <option
                  v-for="(tipo, i) in situacionElemento"
                  :key="i"
                  :value="tipo.idSituacionElemento"
                >
                  {{ situacionElemento[1].situacionElemento }}
                </option>
              </select>
            </div>

            <div class="col-sm-3 col-lg-4 form-group">
              <label>Dia de programación</label>
              <input
                type="text"
                class="form-control"
                placeholder="Dia"
                v-model="tarjeta.diaProgramacion"
                name="diaProgramacion"
              />
            </div>
            <div class="col-sm-3 col-lg-4 form-group">
              <label>Periodicidad de Pago</label>
              <input
                type="text"
                class="form-control"
                :value="periodicidad"
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="habilitaTarjetas" class="boton">
        <input
          class="form-check-input mt-2"
          type="checkbox"
          @change="checkPoliticas($event)"
          id="flexCheckDefault"
        />
        <label class="form-check-label mr-4" for="flexCheckDefault">
          Acepto las condiciones del servicio y la
          <a
            target="_blank"
            href="https://servicios.latinoseguros.com.mx:4431/ovl/archivos/paginas/avisos/aviso_privacidad.pdf"
          >
            política de privavidad
          </a>
        </label>
        <button
          :disabled="btnGuardar"
          @click="altaConvenio"
          class="btn btn-primary"
        >
          Guardar
        </button>
      </div>
    </div>

    <div v-if="error">
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
          <div class="card cardShadow">
            <div class="card-body text-center mt-5 mb-5">
              <i class="fas fa-exclamation-triangle fa-6x"></i>
              <h1 class="mt-4" style="color: #4e5556">Error!</h1>
              <h5 class="mt-1" style="color: #4e5556">{{ mensaje }}</h5>
            </div>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
    </div>

    <div v-if="altaExitosa">
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
          <div class="card cardShadow">
            <div class="info mt-2 text-right mr-4">
              <!-- <span class="badge badge-info mr-2">Año: </span>
                            <span class="badge badge-info mr-2">Folio: </span>
                            <span class="badge badge-info">Id del Convenio:</span> -->
              <span class="badge badge-info mr-2">Año: {{ anioGeneral }}</span>
              <span class="badge badge-info mr-2"
                >Folio: {{ folioGeneral }}</span
              >
              <span class="badge badge-info"
                >Id del Convenio: {{ idConvenioGeneral }}</span
              >
            </div>
            <div class="card-body text-center mt-5 mb-5">
              <i style="color: #4abe25" class="far fa-check-circle fa-6x"></i>
              <!-- <i class="fas fa-exclamation-triangle fa-6x"></i> -->
              <h1 class="mt-3" style="color: #4abe25">Éxito!</h1>
              <h5 class="mt-1" style="color: #4e5556">{{ mensajeExito }}</h5>
            </div>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
    </div>

    <CModal
      :show.sync="modalInformation"
      ref="my-modal"
      :close-on-backdrop="false"
    >
      <template #header-wrapper>
        <div class="text-center"></div>
      </template>
      <div class="row mt-3">
        <div class="col-md-12">
          <p class="textModal">
            El monto máximo fijo del cargo autorizado por el periodo de
            facturación será el indicado en el recibo de primas entregado.
            <br /><br />
            Instruyo y autorizo que con base en la información indicada con
            anterioridad, se realicen cargos periódicos a mi cuenta con la
            finalidad de realizar a La Latinoamericana Seguros S.A. el pago
            correspondiente a la prima o la fracción correspondiente de la
            póliza de seguro <b>{{ poliza }}. </b> <br /><br />
            Esta instrucción y autorización de cargo a mi cuenta se mantendrá
            vigente por plazo indeterminado o bien en lugar de lo anterior, esta
            instrucción y autorización de cargo se mantendrá vigente hasta en
            tanto no exista solicitud de cancelación por mi parte.
            <br /><br />
            Estoy enterado de que en cualquier momento dentro de los primeros 15
            días anteriores al inicio de la vigencia de la póliza podré
            solicitar la cancelación de la presente domiciliación sin costo a mi
            cargo.
          </p>
        </div>
      </div>
      <div class="float-right">
        <button class="btn btn-primary" @click="search">Aceptar</button>
      </div>
      <template #footer-wrapper
        ><span> <div></div> </span
      ></template>
    </CModal>

    <!-- <loading></loading> -->
  </div>
</template>

<script>
import loading from "../../componentes/ImgLoading/loading.vue";
export default {
  components: { loading },
  data() {
    return {
      tiposConvenios: [],
      bancos: [],
      tiposTarjetas: [],
      situacionConvenios: [],
      situacionElemento: [],
      sistemas: [],
      ramosDanios: [],
      pFiliales: [],
      usuario: {
        userName: "137",
        password: "Latino2022",
      },
      convenio: {
        tipoConvenio: "",
        banco: "",
        correo: "",
        tipoTarjeta: "",
        situacionConvenio: "",
        telefono: "",
      },
      tarjeta: {
        numeroTarjeta: "",
        titular: "",
        mes: "",
        año: "",
        cvv: "",
        situacion: "",
        diaProgramacion: "",
      },
      filial: {
        numeroFilial1: "",
        numeroFilial2: "",
        numeroFilial3: "",
        numeroFilial4: "",
        nombreFilial1: "",
        nombreFilial2: "",
        nombreFilial3: "",
        nombreFilial4: "",
      },
      isFilial: "",
      mensaje: "",
      nombreContratante: "",
      maxL: "",
      mensajeExito: "",
      maxCVV: "",
      anioGeneral: "",
      folioGeneral: "",
      idConvenioGeneral: "",
      storage: "",
      periodicidad: "",
      poliza: "",
      filiales: true,
      btnGuardar: true,
      altaExitosa: false,
      habilitaTarjetas: false,
      contenedor: false,
      error: false,
      isCheked: false,
      loadingIn: false,
      modalInformation: false,
      token: this.$route.params.datos,
    };
  },
  methods: {
    cambia(event, tipo) {
      switch (tipo) {
        case "convenio":
          this.convenio.tipoConvenio = event.target.value;
          break;
        case "banco":
          this.convenio.banco = event.target.value;
          if (event.target.value == 16) {
            this.maxL = 18;
            this.maxCVV = 4;
          } else {
            this.maxL = 19;
            this.maxCVV = 3;
          }
          break;
        case "tarjeta":
          this.convenio.tipoTarjeta = event.target.value;
          break;
        default:
          break;
      }
    },
    async login() {
      this.loadingIn = true;
      this.$store.dispatch(
        "loginPagoLinea",
        { usuario: this.usuario },
        this.storage
      );
      this.loadingIn = false;
    },
    async obtenerCatalogo(tipo) {
      const payload = {
        metodo: "COBRANZACONSULTACATALOGO",
        data: {
          pIdUsuario: localStorage.getItem("userId"),
          pOpcion: tipo,
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        switch (tipo) {
          case "TipoConvenio":
            this.tiposConvenios.push(...response);
            break;
          case "Bancos":
            this.bancos.push(...response);
            break;
          case "TipoElementoSencillo":
            this.tiposTarjetas.push(...response);
            break;
          case "SituacionConvenio":
            this.situacionConvenios.push(...response);
            break;
          case "SituacionElemento":
            this.situacionElemento.push(...response);
            break;
          default:
            break;
        }
      }
    },
    check(event) {
      this.isCheked = event.target.checked;
      if (this.isCheked) {
        this.filiales = false;
        this.filial.numeroFilial1 = "";
        this.filial.numeroFilial2 = "";
        this.filial.numeroFilial3 = "";
        this.filial.numeroFilial4 = "";
        this.filial.nombreFilial1 = "";
        this.filial.nombreFilial2 = "";
        this.filial.nombreFilial3 = "";
        this.filial.nombreFilial4 = "";
      } else {
        this.filiales = true;
      }
    },
    checkPoliticas(event) {
      let isCheked = event.target.checked;
      if (isCheked) {
        this.btnGuardar = false;
      } else {
        this.btnGuardar = true;
      }
    },
    async procesa() {
      this.loadingIn = true;
      const payload = {
        metodo: "PROCESA",
        data: {
          pAccion: 3,
          pValor: this.token,
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.contenedor = true;
        this.isFilial = response[0].valor;
        this.poliza = response[0].poliza;
        // this.isFilial = 1
        if (this.isFilial == -1) {
          this.error = true;
          this.contenedor = false;
          this.mensaje = response[0].mensaje;
        }
      }
      this.loadingIn = false;
    },
    async search() {
      this.modalInformation = false;
      this.pFiliales = [];
      if (this.validate()) {
        return;
      } else {
        if (
          this.filial.nombreFilial1 != "" &&
          this.filial.numeroFilial1 != ""
        ) {
          let filiales1 = {
            pNumFilial: this.filial.numeroFilial1,
            pNombreFilial: this.filial.nombreFilial1.toUpperCase(),
          };
          this.pFiliales.push(filiales1);
        }
        if (
          this.filial.nombreFilial2 != "" ||
          this.filial.numeroFilial2 != ""
        ) {
          let filiales2 = {
            pNumFilial: this.filial.numeroFilial2,
            pNombreFilial: this.filial.nombreFilial2.toUpperCase(),
          };
          this.pFiliales.push(filiales2);
        }
        if (
          this.filial.nombreFilial3 != "" &&
          this.filial.numeroFilial3 != ""
        ) {
          let filiales3 = {
            pNumFilial: this.filial.numeroFilial3,
            pNombreFilial: this.filial.nombreFilial3.toUpperCase(),
          };
          this.pFiliales.push(filiales3);
        }
        if (
          this.filial.nombreFilial4 != "" &&
          this.filial.numeroFilial4 != ""
        ) {
          let filiales4 = {
            pNumFilial: this.filial.numeroFilial4,
            pNombreFilial: this.filial.nombreFilial4.toUpperCase(),
          };
          this.pFiliales.push(filiales4);
        }
        const payload = {
          metodo: "PAGOLINEAVERIFICA",
          data: {
            pValor: this.token,
            pNombre: this.nombreContratante.toUpperCase(),
            pIdUsuario: "WEB",
            pFiliales: this.pFiliales,
          },
        };
        this.loadingIn = true;
        const res = await this.$store.dispatch("metodoPost", payload);
        if (res) {
          const response = this.$store.getters.getRespuestaREST;
          if (response[0].valor == 1) {
            this.habilitaTarjetas = true;
          } else if (response[0].valor == -1) {
            this.habilitaTarjetas = false;
            this.$swal({
              icon: "error",
              title: "Error",
              text: response[0].mensaje,
              color: "#000000",
              showConfirmButton: true,
              background: "#fff",
              backdrop: `
                                rgba(0,0,123,0.4)
                            `,
            });
          }
        }
        this.loadingIn = false;
      }
    },
    validate() {
      if (this.nombreContratante == "") {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar el Nombre completo del contratante",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return true;
      }
      if (this.isFilial == 1 && this.isCheked == false) {
        if (
          this.filial.nombreFilial1 == "" &&
          this.filial.numeroFilial1 == "" &&
          this.filial.nombreFilial2 == "" &&
          this.filial.numeroFilial2 == "" &&
          this.filial.nombreFilial3 == "" &&
          this.filial.numeroFilial3 == "" &&
          this.filial.nombreFilial4 == "" &&
          this.filial.numeroFilial4 == ""
        ) {
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Debe ingresar al menos una filial completa.",
            color: "#000000",
            showConfirmButton: true,
            background: "#fff",
            backdrop: `
                        rgba(0,0,123,0.4)
                    `,
          });
          return true;
        }
      }
      if (
        (this.filial.nombreFilial1 != "" && this.filial.numeroFilial1 == "") ||
        (this.filial.nombreFilial1 == "" && this.filial.numeroFilial1 != "")
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar el Núm. Filial y Nombre de la Filial 1",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return true;
      }
      if (
        (this.filial.nombreFilial2 != "" && this.filial.numeroFilial2 == "") ||
        (this.filial.nombreFilial2 == "" && this.filial.numeroFilial2 != "")
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar el Núm. Filial y Nombre de la Filial 2",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return true;
      }
      if (
        (this.filial.nombreFilial3 != "" && this.filial.numeroFilial3 == "") ||
        (this.filial.nombreFilial3 == "" && this.filial.numeroFilial3 != "")
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar el Núm. Filial y Nombre de la Filial 3",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return true;
      }
      if (
        (this.filial.nombreFilial4 != "" && this.filial.numeroFilial4 == "") ||
        (this.filial.nombreFilial4 == "" && this.filial.numeroFilial4 != "")
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar el Núm. Filial y Nombre de la Filial 4",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return true;
      } else {
        return false;
      }
    },
    vaidacionesAlta() {
      if (
        !this.convenio.tipoConvenio ||
        this.convenio.tipoConvenio === 0 ||
        this.convenio.tipoConvenio === "0"
      ) {
        this.$swal("Alerta", "Debe seleccionar un Tipo de Convenio.");
        return;
      }

      if (
        !this.convenio.banco ||
        this.convenio.banco === 0 ||
        this.convenio.banco === "0"
      ) {
        this.$swal("Alerta", "Debe seleccionar un Banco.");
        return;
      }

      let validateEmail = new RegExp(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      );

      if (!validateEmail.test(this.convenio.correo)) {
        this.$swal("Alerta", "Ingrese un Correo electronico valido.");
        return;
      }
      if (!this.convenio.telefono || this.convenio.telefono.length !== 10) {
        this.$swal(
          "Alerta",
          "Debe ingresar un número de teléfono válido de 10 dígitos."
        );
        return;
      }
      if (this.tarjeta.mes.length < 2 || this.tarjeta.mes.length > 2) {
        this.$swal("Alerta", "El mes de vencimiento debe ser a dos digitos.");
        return;
      }
      if (this.tarjeta.año.length < 4 || this.tarjeta.año.length > 4) {
        this.$swal(
          "Alerta",
          "El año de vencimiento debe ser a cuatro digitos."
        );
        return;
      }

      let validateOnlyNumbers = new RegExp(/^([0-9])*$/);

      if (!validateOnlyNumbers.test(this.tarjeta.mes)) {
        this.$swal("Alerta", "El formato de Mes de vencimiento es invalido");
        return;
      }
      if (!validateOnlyNumbers.test(this.tarjeta.año)) {
        this.$swal("Alerta", "El formato de Año de vencimiento es invalido");
        return;
      }
      if (!validateOnlyNumbers.test(this.tarjeta.numeroTarjeta)) {
        this.$swal("Alerta", "El formato del Número de Tarjeta es invalido");
        return;
      }
      if (
        !this.tarjeta.numeroTarjeta ||
        this.tarjeta.numeroTarjeta.length !== this.maxL
      ) {
        this.$swal(
          "Alerta",
          `Debe ingresar un número de tarjeta válido de ${this.maxL} dígitos.`
        );
        return;
      }
      if (!this.tarjeta.titular || this.tarjeta.titular.trim() === "") {
        this.$swal(
          "Alerta",
          "Debe ingresar el nombre del titular de la tarjeta."
        );
        return;
      }
      if (
        !this.tarjeta.cvv ||
        this.tarjeta.cvv.length !== this.maxCVV ||
        !/^\d+$/.test(this.tarjeta.cvv)
      ) {
        this.$swal(
          "Alerta",
          `Debe ingresar un CVV válido de ${this.maxCVV} dígitos.`
        );
        return;
      }
      if (
        !this.tarjeta.diaProgramacion ||
        !/^\d+$/.test(this.tarjeta.diaProgramacion)
      ) {
        this.$swal("Alerta", "Debe ingresar un Día de Programación válido.");
        return;
      }
    },
    async altaConvenio() {
      if (
        this.tarjeta.mes == "" &&
        this.tarjeta.año == "" &&
        this.convenio.banco == "" &&
        this.convenio.tipoTarjeta == "" &&
        this.tarjeta.numeroTarjeta == "" &&
        this.tarjeta.cvv == "" &&
        this.tarjeta.titular == "" &&
        this.convenio.tipoConvenio == "" &&
        this.convenio.correo == "" &&
        this.convenio.telefono == ""
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Es necesario seleccionar al menos un filtro",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }
      let validateEmail = new RegExp(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      );
      if (
        !this.convenio.tipoConvenio ||
        this.convenio.tipoConvenio === 0 ||
        this.convenio.tipoConvenio === "0"
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe seleccionar un Tipo de Convenio.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `rgba(0,0,123,0.4)`,
        });
        return;
      }
      if (
        !this.convenio.banco ||
        this.convenio.banco === 0 ||
        this.convenio.banco === "0"
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe seleccionar un Banco.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `rgba(0,0,123,0.4)`,
        });
        return;
      }

      if (!validateEmail.test(this.convenio.correo)) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ingrese un Correo electronico valido.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }
      if (
        !this.convenio.tipoTarjeta ||
        this.convenio.tipoTarjeta === 0 ||
        this.convenio.tipoTarjeta === "0"
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe seleccionar un Tipo de Tarjeta.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
        rgba(0,0,123,0.4)
    `,
        });
        return;
      }
      if (!this.convenio.telefono) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar un numero de telefono.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
        rgba(0,0,123,0.4)
    `,
        });
        return;
      }
      if (!this.tarjeta.numeroTarjeta) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar un numero de tarjeta.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
        rgba(0,0,123,0.4)
    `,
        });
        return;
      }
      if (!this.tarjeta.titular) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar el nombre del titular.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
        rgba(0,0,123,0.4)
    `,
        });
        return;
      }

      if (this.tarjeta.mes.length < 2 || this.tarjeta.mes.length > 2) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "El mes de vencimiento debe ser a dos digitos.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }
      if (this.tarjeta.año.length < 4 || this.tarjeta.año.length > 4) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "El año de vencimiento debe ser a cuatro digitos.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }

      let validateOnlyNumbers = new RegExp(/^([0-9])*$/);

      if (!validateOnlyNumbers.test(this.tarjeta.mes)) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "El formato de Mes de vencimiento es invalido",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }
      if (!validateOnlyNumbers.test(this.tarjeta.año)) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "El formato de Año de vencimiento es invalido.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }
      if (!this.tarjeta.cvv) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Debe ingresar el CVV.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }
     
      if (
        !validateOnlyNumbers.test(
          this.tarjeta.numeroTarjeta.trim().replace(/\s+/g, "")
        )
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "El formato del Número de Tarjeta es invalido.",
          color: "#000000",
          showConfirmButton: true,
          background: "#fff",
          backdrop: `
                        rgba(0,0,123,0.4)
                    `,
        });
        return;
      }

      const payload = {
        metodo: "PAGOLINEALTA",
        data: {
          pValor: this.token,
          pNombre: this.nombreContratante.toUpperCase(),
          pIdUsuario: "WEB",
          pFiliales: this.pFiliales,
          pDatosNuevo: {
            pIdBanco: this.convenio.banco,
            pIdTipoElemento: this.convenio.tipoTarjeta,
            pNumConvenio: btoa(
              this.tarjeta.numeroTarjeta.trim().replace(/\s+/g, "")
            ),
            pValor1: btoa(this.tarjeta.mes),
            pValor2: btoa(this.tarjeta.año),
            pValor3: btoa(this.tarjeta.cvv),
            pDiaProgramacion:
              this.tarjeta.diaProgramacion == ""
                ? "-1"
                : this.tarjeta.diaProgramacion,
            pIdSituacionElemento: "1",
            pTitular: this.tarjeta.titular,
            p1IdTipoConvenio: this.convenio.tipoConvenio,
            p1Correo: this.convenio.correo,
            p1Telefono: this.convenio.telefono,
            p1IdSituacionConvenio: "1",
            pUsuarioRegistro: "WEB",
          },
        },
      };
      this.loadingIn = true;
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        if (response[0].valor != -1) {
          this.altaExitosa = true;
          this.contenedor = false;
          this.mensajeExito = response[0].mensaje;
          this.anioGeneral = response[0].anio;
          this.folioGeneral = response[0].folio;
          this.idConvenioGeneral = response[0].valor;
        } else if (response[0].valor == -1) {
          this.$swal({
            icon: "error",
            title: "Error",
            text: response[0].mensaje,
            color: "#000000",
            showConfirmButton: true,
            background: "#fff",
            backdrop: `
                        rgba(0,0,123,0.4)
                    `,
          });
        }
      }
      this.loadingIn = false;
    },
    replaceTarget(e) {
      let numT = e.target.value;
      this.tarjeta.numeroTarjeta = e.target.value
        .replace(/\s/g, "")
        .replace(/\D/g, "")
        .replace(/([0-9]{4})/g, "$1 ")
        .trim();
    },
    async valida() {
      const payload = {
        metodo: "PAGOLINEAVALIDA",
        data: {
          pAccion: "3",
          pValor: this.token,
        },
      };
      this.loadingIn = true;
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
      }
      this.loadingIn = false;
    },
    async periodicidadPago() {
      const payload = {
        metodo: "PERIODICIDAD",
        data: {
          pValor: this.token,
        },
      };
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.periodicidad = response[0].mensaje;
      }
    },
  },
  async mounted() {
    this.loadingIn = true;
    await this.login();
    setTimeout(async (_) => {
      await this.procesa();
      await this.obtenerCatalogo("TipoConvenio");
      await this.obtenerCatalogo("Bancos");
      await this.obtenerCatalogo("TipoElementoSencillo");
      await this.obtenerCatalogo("SituacionConvenio");
      await this.obtenerCatalogo("SituacionElemento");
      await this.periodicidadPago();
    }, "1000");
    this.loadingIn = false;
    // this.modalInformation = true;
  },
};
</script>

<style>
.textModal {
  color: black;
  text-align: justify;
  margin: 20px;
}
.numero {
  font-size: 16px;
}
.cardShadow {
  box-shadow: 10px;
}
.contenedor {
  margin: 20px;
}
.boton {
  float: right;
  margin-bottom: 20px;
}
</style>
